(() => {
  const root = document.getElementById('CbWelcomePopup');
  if (!root) return;

  const closeButtons = root.querySelectorAll('[data-cb-welcome-close]');
  const dialog = root.querySelector('[data-cb-welcome-dialog]');
  const email = root.querySelector('input[type="email"]');
  const form = root.querySelector('form');
  const copyButton = root.querySelector('[data-cb-copy-code]');
  const copyLabel = root.querySelector('[data-cb-copy-label]');
  const success = root.dataset.success === 'true';
  const hasError = root.dataset.error === 'true';
  const designMode = root.dataset.designMode === 'true';
  const customerOrders = Number.parseInt(root.dataset.customerOrders || '-1', 10);
  const delayMs = Number.parseInt(root.dataset.delay || '18000', 10);
  const scrollThreshold = Number.parseFloat(root.dataset.scroll || '0.35');
  const suppressDays = Number.parseInt(root.dataset.suppressDays || '7', 10);
  const suppressMs = suppressDays * 24 * 60 * 60 * 1000;
  const closedKey = 'cbWelcome10ClosedAt';
  const subscribedKey = 'cbWelcome10Subscribed';
  let opened = false;
  let lastFocused = null;
  let timer = null;

  const storage = {
    get(key) {
      try { return window.localStorage.getItem(key); } catch (_) { return null; }
    },
    set(key, value) {
      try { window.localStorage.setItem(key, value); } catch (_) {}
    }
  };

  const track = (eventName, detail = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...detail });
  };

  const isSuppressed = () => {
    if (designMode || success || hasError) return false;
    if (customerOrders > 0) return true;
    if (storage.get(subscribedKey) === '1') return true;
    const closedAt = Number.parseInt(storage.get(closedKey) || '0', 10);
    return closedAt > 0 && Date.now() - closedAt < suppressMs;
  };

  const removeTriggers = () => {
    if (timer) window.clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onExitIntent);
  };

  const open = (trigger) => {
    if (opened || isSuppressed()) return;
    opened = true;
    removeTriggers();
    lastFocused = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('cb-welcome-open');
    window.requestAnimationFrame(() => root.classList.add('is-open'));
    const focusTarget = email || dialog;
    if (focusTarget && typeof focusTarget.focus === 'function') {
      window.setTimeout(() => focusTarget.focus({ preventScroll: true }), 120);
    }
    track('cb_welcome_view', { trigger });
  };

  const close = (reason = 'close') => {
    if (!opened && root.hidden) return;
    root.classList.remove('is-open');
    storage.set(closedKey, String(Date.now()));
    window.setTimeout(() => {
      root.hidden = true;
      document.documentElement.classList.remove('cb-welcome-open');
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus({ preventScroll: true });
    }, 180);
    opened = false;
    track('cb_welcome_close', { reason });
  };

  function onScroll() {
    const scrollable = Math.max(document.documentElement.scrollHeight - window.innerHeight, 0);
    if (!scrollable) return;
    if (window.scrollY / scrollable >= scrollThreshold) open('scroll');
  }

  function onExitIntent(event) {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    if (event.relatedTarget || event.toElement) return;
    if (event.clientY <= 8) open('exit_intent');
  }

  const onKeydown = (event) => {
    if (!opened) return;
    if (event.key === 'Escape') {
      close('escape');
      return;
    }
    if (event.key !== 'Tab' || !dialog) return;
    const focusable = Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter((el) => !el.hidden && el.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  closeButtons.forEach((button) => button.addEventListener('click', () => close(button.dataset.cbWelcomeClose || 'close')));
  document.addEventListener('keydown', onKeydown);

  if (form) {
    form.addEventListener('submit', () => track('cb_welcome_submit'));
  }

  if (copyButton) {
    copyButton.addEventListener('click', async () => {
      const code = copyButton.dataset.code || 'KAKTUS10';
      try {
        await navigator.clipboard.writeText(code);
        if (copyLabel) copyLabel.textContent = 'Kopiert';
        track('cb_welcome_code_copy');
      } catch (_) {
        if (copyLabel) copyLabel.textContent = code;
      }
    });
  }

  if (success) {
    storage.set(subscribedKey, '1');
    storage.set(closedKey, '0');
    open('success');
    track('cb_welcome_success');
    return;
  }

  if (hasError) {
    open('form_error');
    return;
  }

  if (isSuppressed()) return;

  if (designMode) {
    timer = window.setTimeout(() => open('theme_editor'), 600);
    return;
  }

  timer = window.setTimeout(() => open('timer'), delayMs);
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('mouseout', onExitIntent);
})();